import type { ReactElement } from 'react';
import { PaymentService } from 'config';
import Braintree from 'services/Braintree';
import type { OnToken } from 'services/Braintree';
import { Component as VenmoButton } from 'payment-img/venmo/blue-venmo-button.svg';

type Props = {
  show: boolean;
  onToken: OnToken;
};

function VenmoProvider({ show, onToken }: Props): ReactElement {
  return (
    <div
      className={[
        'c-payment-form__body',
        'c-payment-form__body--google-pay',
        'collapse',
        show ? 'show' : '',
      ].join(' ')}
    >
      <div className="c-alternative-payment-buttons">
        <div>
          <button
            id="payment-method-venmo"
            type="button"
            className="c-link"
            aria-label="Venmo"
            onClick={() => {
              Braintree.triggerVenmo(
                (token) => setTimeout(() => {
                  onToken(PaymentService.VENMO, token);
                }, 1500),
              );
            }}
          >
            <VenmoButton height={32} width={250} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default VenmoProvider;
